import { Outlet } from "react-router";

export default function Partners() {
    return (
      <div>
  
        {/* This element will render either <DashboardMessages> when the URL is
            "/messages", <DashboardTasks> at "/tasks", or null if it is "/"
        */}
        <Outlet />
      </div>
    );
  }